/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const cognitoDomain = (import.meta.env.REACT_APP_COGNITO_DOMAIN || '').replace('https://', '');

const awsmobile = {
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  aws_project_region: import.meta.env.REACT_APP_BUCKET_REGION,
  aws_cognito_identity_pool_id: import.meta.env.REACT_APP_COGNITO_IDENTITY_ID,
  aws_cognito_region: import.meta.env.REACT_APP_COGNITO_REGION,
  aws_user_pools_id: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: import.meta.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
  aws_user_files_s3_bucket: import.meta.env.REACT_APP_BUCKET_NAME,
  aws_user_files_s3_bucket_region: import.meta.env.REACT_APP_BUCKET_REGION,
  ...(cognitoDomain && {
    oauth: {
      domain: cognitoDomain,
      scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${window.location.origin}/social-auth`,
      redirectSignOut: `${window.location.origin}/sign-in`,
      responseType: 'code',
    },
  }),
};

export default awsmobile;
